import React, { useEffect } from 'react';
import { differenceInDays } from 'date-fns';

import { Flex } from '@atlaskit/primitives';

import {
	deserializeState,
	useGetOnboardingState,
	useOnboardingState,
} from '@confluence/onboarding-helpers/entry-points/hooks/useOnboardingState';

import { HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS } from './homeOnboardingTakeoverV2OnboardingStateKeys';
import { useOnboardingActions } from './useOnboardingActions';
import { HTV2Carousel } from './HTV2Carousel';
import { HTV2LearningOpportunityCardsList } from './HTV2LearningOpportunityCardsList';
import { HTV2Header } from './HTV2Header';

export const HomeOnboardingTakeoverV2 = () => {
	const onboardingActions = useOnboardingActions();
	const { setOnboardingState } = useOnboardingState();
	const { data: onboardingStateData, loading: onboardingStateLoading } = useGetOnboardingState(
		HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS.takeoverSeenAt,
	);
	const { takeoverSeenAt } = deserializeState(onboardingStateData);

	useEffect(() => {
		if (!onboardingStateLoading && !Boolean(takeoverSeenAt)) {
			setOnboardingState({
				key: HOME_ONBOARDING_TAKEOVER_V2_ONBOARDING_STATE_KEYS.takeoverSeenAt,
				value: new Date().toISOString(),
			});
		}
	}, [onboardingStateLoading, takeoverSeenAt, setOnboardingState]);

	const onboardingPeriodDay = takeoverSeenAt
		? differenceInDays(new Date(), new Date(takeoverSeenAt))
		: 0;

	return (
		<Flex direction="column" gap="space.200" testId="home-onboarding-takeover-v2">
			<HTV2Header />
			<HTV2Carousel actions={onboardingActions} />
			{<HTV2LearningOpportunityCardsList onboardingPeriodDay={onboardingPeriodDay} />}
		</Flex>
	);
};
